import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { guardPermitAdminRoute } from '../modules/Permits/permitAdminRouteGuard';
import { PermitSettingsPage } from '../modules/Permits/PermitSettings/PermitSettingsPage';

// Permitting settings (docs/modules/permitting-workspace.md, screen 7): the pick lists,
// PermitAdmin only. The list shown lives in the address so it can be shared.
export const Route = createFileRoute('/permitting_/settings')({
  component: PermitSettingsPage,
  validateSearch: z.object({
    list: z
      .enum(['blockers', 'next-actions', 'jurisdictions', 'inspection-types', 'handoffs'])
      .optional(),
  }),
  loader({ context }) {
    guardPermitAdminRoute(context.authContext.user);
  },
  head() {
    return {
      meta: [{ title: 'Permitting settings' }],
    };
  },
});
